export const FILE_PIN_URL = `https://api.pinata.cloud/pinning/pinFileToIPFS`;

export const JSON_PIN_URL = `https://api.pinata.cloud/pinning/pinJSONToIPFS`;
